import React from "react";
import { Link } from "react-router-dom";
import {Dropdown} from "react-bootstrap";
import { connect } from "react-redux";
import HeaderDropdownToggle from "../content/CustomDropdowns/HeaderDropdownToggle";
import { PERMISSIONS } from "../../utils/Permissions";
import { hasPermission } from "../../utils/Utils";

function UserProfile({ user, permissions, showHi, showAvatar }) {
	const podeVerMeuPatio = hasPermission(permissions, PERMISSIONS.PATIO_VIEW);
	const podeVerColaboradores = hasPermission(permissions, PERMISSIONS.USUARIO_PATIO_GROUPS_LIST);

	return (
		<Dropdown className="kt-header__topbar-item kt-header__topbar-item--user" drop="down" align="end">
			<Dropdown.Toggle as={HeaderDropdownToggle} id="dropdown-toggle-user-profile">
				<div className="kt-header__topbar-user">
					{showHi && (
						<div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end', flexDirection: 'column' }}>
							<span className="kt-header__topbar-username kt-hidden-mobile" style={{ alignSelf: 'flex-end' }}>{user.upa_nome}</span>
							<span className="kt-header__topbar-username kt-hidden-mobile" style={{ fontSize: 12, color: 'gray', alignSelf: 'flex-end' }}>
								{user.patio?.pat_nome_fantasia}
							</span>
						</div>
					)}

					{showAvatar &&
						<div style={{
							width: '34px', height: '34px', backgroundImage: `url(${user.foto ? user.foto : '/images/no-profile.png'})`,
							backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: '50% 50%', borderRadius: '50%'
						}} />
					}
				</div>
			</Dropdown.Toggle>

			<Dropdown.Menu className="dropdown-menu-fit dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-xl">
				<div className="kt-user-card kt-user-card--skin-dark kt-notification-item-padding-x"
					style={{ backgroundColor: 'var(--color-secondary)' }}>

					{showAvatar &&
						<div className="kt-user-card__avatar">
							<span className="kt-badge kt-badge--lg kt-badge--rounded kt-badge--bold kt-font-success">
								<img alt="" src={user.foto ? user.foto : '/images/no-profile.png'} />
							</span>
						</div>
					}

					<div className="kt-user-card__name">{user.upa_nome}</div>
				</div>
				<div className="kt-notification">
					<Link to="/perfil" className="kt-notification__item">
						<div className="kt-notification__item-icon">
							<i className="fas fa-id-card" />
						</div>
						<div className="kt-notification__item-details">
							<div className="kt-notification__item-title kt-font-bold">Meu Perfil</div>
							<div className="kt-notification__item-time">Veja e atualize seus dados pessoais.</div>
						</div>
					</Link>

					{podeVerMeuPatio && (
						<Link to="/meu-patio" className="kt-notification__item">
							<div className="kt-notification__item-icon">
								<i className="fas fa-warehouse" />
							</div>
							<div className="kt-notification__item-details">
								<div className="kt-notification__item-title kt-font-bold">Meu pátio</div>
								<div className="kt-notification__item-time">Dados cadastrais e localização do pátio.</div>
							</div>
						</Link>
					)}

					{podeVerColaboradores && (
						<Link to="/colaborador" className="kt-notification__item">
							<div className="kt-notification__item-icon">
								<i className="fas fa-user-shield" />
							</div>
							<div className="kt-notification__item-details">
								<div className="kt-notification__item-title kt-font-bold">Meus colaboradores</div>
								<div className="kt-notification__item-time">Colaboradores e grupos de acesso do pátio.</div>
							</div>
						</Link>
					)}

					<div className="kt-notification__custom">
						<Link to="/logout" className="btn btn-primary btn-bold">Sair</Link>
					</div>
				</div>
			</Dropdown.Menu>
		</Dropdown>
	);
}

const mapStateToProps = ({ auth: { user, permissions } }) => ({ user, permissions });

export default connect(mapStateToProps)(UserProfile);
